import clsx from 'clsx';
import React from 'react';
import { LOGO_DEFAULT_ALT } from './logo.constants';
import { getLogoSrc } from './getLogoSrc';
import type { LogoProps } from './logo.types';

function Logo({
  color,
  state,
  alt = LOGO_DEFAULT_ALT,
  className,
  ...imgProps
}: LogoProps) {
  return (
    <img
      {...imgProps}
      src={getLogoSrc(color, state)}
      alt={alt}
      className={clsx('hl-logo', className)}
    />
  );
}

export default Logo;
